// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"e6969b34","372":"97796306","933":"241e15c4","964":"1daa7960"}[chunkId] + ".chunk.css";
};